(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function macPokemonSinglesMultiSelect() {
  const PATH = '/collections/pokemon-singles';
  if (!window.location.pathname.startsWith(PATH)) return;

  const PREVIEW_PARAMS = ['preview_theme_id', '_fd', 'pb'];
  const STATE_PREFIX = 'macf_';
  let activeRequest = null;

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const quote = (value) => String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  const tagTerm = (value) => `tag:"${quote(value)}"`;
  const titleTerm = (value) => `title:"${quote(value)}"`;
  const orClause = (terms) => terms.length > 1 ? `(${terms.join(' OR ')})` : (terms[0] || '');

  const groupKey = (summaryText) => {
    const text = String(summaryText || '').replace('+', '').trim().toLowerCase();
    if (text === 'product type') return 'product_type';
    if (text === 'finish') return 'finish';
    if (text === 'rarity') return 'rarity';
    if (text === 'condition') return 'condition';
    if (text === 'set') return 'set';
    if (text === 'character') return 'character';
    if (text === 'language') return 'language';
    if (text === 'type / energy') return 'energy';
    if (text === 'game') return 'game';
    return '';
  };

  const labelFor = (input) => {
    return input.closest('.mac-filter-check')?.querySelector('span')?.textContent?.trim() || input.value || '';
  };

  const ensureFixedFinishOptions = (sidebar) => {
    const finishDetails = [...sidebar.querySelectorAll('details.mac-tcg-menu')].find((details) => {
      return groupKey(details.querySelector(':scope > summary')?.textContent) === 'finish';
    });
    if (!finishDetails) return;

    const list = finishDetails.querySelector('.mac-filter-list');
    if (!list) return;

    const existing = new Set(
      [...list.querySelectorAll('.mac-filter-check span')].map((span) => span.textContent.trim().toLowerCase())
    );

    const desired = [
      ['Holo', 'holo'],
      ['Reverse Holo', 'reverse-holo'],
      ['Non Holo', 'non-holo'],
      ['IR - Illustration Rare', 'ir'],
      ['SIR - Special Illustration Rare', 'sir'],
      ['Double Rare', 'double-rare'],
      ['Ultra Rare', 'ultra-rare'],
      ['Hyper Rare', 'hyper-rare'],
      ['Full Art', 'full-art'],
      ['Gold', 'gold'],
      ['Poké Ball', 'poke-ball'],
      ['Master Ball', 'master-ball'],
      ['Promo', 'promo'],
      ['Shiny Rare', 'shiny-rare']
    ];

    desired.forEach(([label, value]) => {
      const normalized = label.replace(/^ir - |^sir - /i, '').trim().toLowerCase();
      const aliases = [label.toLowerCase(), normalized];
      if (aliases.some((alias) => existing.has(alias))) return;

      const li = document.createElement('li');
      li.setAttribute('data-filter-item', '');
      li.innerHTML = `<label class="mac-filter-check"><input type="checkbox" data-mac-filter-checkbox data-mac-fixed-finish="${value}" value="${value}"><span>${label}</span></label>`;
      list.appendChild(li);
    });

    const empty = list.querySelector('.mac-filter-empty');
    if (empty && list.querySelector('[data-mac-filter-checkbox]')) empty.remove();
  };

  const collect = (sidebar) => {
    const groups = {};
    sidebar.querySelectorAll('details.mac-tcg-menu').forEach((details) => {
      const key = groupKey(details.querySelector(':scope > summary')?.textContent);
      if (!key) return;
      const checked = [...details.querySelectorAll('input[data-mac-filter-checkbox]:checked')];
      if (!checked.length) return;
      groups[key] = checked.map((input) => ({
        label: labelFor(input),
        fixedFinish: input.dataset.macFixedFinish || ''
      }));
    });
    return groups;
  };

  const finishTerm = (item) => {
    const code = item.fixedFinish;
    switch (code) {
      case 'holo':
        return `(${titleTerm('Holo')} AND -${titleTerm('Reverse Holo')})`;
      case 'reverse-holo':
        return `(${titleTerm('Reverse Holo')} OR ${tagTerm('Reverse Holo')} OR ${tagTerm('Reverse Holofoil')})`;
      case 'non-holo':
        return `(${titleTerm('Non Holo')} OR ${titleTerm('Non-Holo')} OR ${tagTerm('Non Holo')} OR ${tagTerm('Normal')})`;
      case 'ir':
        return `(${tagTerm('Illustration Rare')} OR ${tagTerm('IR')})`;
      case 'sir':
        return `(${tagTerm('Special Illustration Rare')} OR ${tagTerm('SIR')})`;
      case 'double-rare':
        return `(${tagTerm('Double Rare')} OR ${tagTerm('DR')})`;
      case 'ultra-rare':
        return `(${tagTerm('Ultra Rare')} OR ${tagTerm('UR')})`;
      case 'hyper-rare':
        return tagTerm('Hyper Rare');
      case 'full-art':
        return `(${tagTerm('Full Art')} OR ${tagTerm('Alternate Art')} OR ${tagTerm('Alt Art')})`;
      case 'gold':
        return `(${tagTerm('Gold')} OR ${tagTerm('Hyper Rare')})`;
      case 'poke-ball':
        return `(${tagTerm('Poké Ball')} OR ${tagTerm('Poke Ball')} OR ${titleTerm('Poké Ball')} OR ${titleTerm('Poke Ball')})`;
      case 'master-ball':
        return `(${tagTerm('Master Ball')} OR ${titleTerm('Master Ball')})`;
      case 'promo':
        return tagTerm('Promo');
      case 'shiny-rare':
        return tagTerm('Shiny Rare');
      default: {
        const label = item.label.replace(/^IR\s*-\s*/i, '').replace(/^SIR\s*-\s*/i, '').trim();
        if (/^holo$/i.test(label)) return `(${titleTerm('Holo')} AND -${titleTerm('Reverse Holo')})`;
        if (/reverse holo/i.test(label)) return `(${titleTerm('Reverse Holo')} OR ${tagTerm(label)})`;
        if (/illustration rare/i.test(label) && !/special/i.test(label)) return tagTerm('Illustration Rare');
        if (/special illustration rare/i.test(label)) return tagTerm('Special Illustration Rare');
        return tagTerm(label);
      }
    }
  };

  const termFor = (group, item) => {
    if (group === 'finish') return finishTerm(item);
    if (group === 'character') {
      const character = item.label.replace(/^IR\s*-\s*/i, '').replace(/^SIR\s*-\s*/i, '').trim();
      return titleTerm(character);
    }
    return tagTerm(item.label);
  };

  const buildQuery = (groups) => {
    const base = [
      tagTerm('Pokémon TCG'),
      `-${tagTerm('complete-your-set')}`,
      `-${tagTerm('Common')}`,
      `-${tagTerm('Uncommon')}`,
      `-${tagTerm('Rare')}`,
      `-${tagTerm('Double Rare')}`
    ];

    const clauses = [...base];
    Object.entries(groups).forEach(([group, items]) => {
      const terms = items.map((item) => termFor(group, item)).filter(Boolean);
      if (terms.length) clauses.push(orClause(terms));
    });
    return clauses.join(' AND ');
  };

  const saveState = (groups) => {
    const url = new URL(window.location.href);
    [...url.searchParams.keys()].forEach((key) => {
      if (key.startsWith(STATE_PREFIX)) url.searchParams.delete(key);
    });

    Object.entries(groups).forEach(([group, items]) => {
      const encoded = items.map((item) => item.fixedFinish ? `@${item.fixedFinish}` : item.label);
      if (encoded.length) url.searchParams.set(`${STATE_PREFIX}${group}`, encoded.join('||'));
    });
    url.searchParams.delete('page');
    window.history.replaceState({ macPokemonFilters: true }, '', url.toString());
  };

  const restoreState = (sidebar) => {
    const url = new URL(window.location.href);
    sidebar.querySelectorAll('input[data-mac-filter-checkbox]').forEach((input) => { input.checked = false; });

    sidebar.querySelectorAll('details.mac-tcg-menu').forEach((details) => {
      const group = groupKey(details.querySelector(':scope > summary')?.textContent);
      if (!group) return;
      const raw = url.searchParams.get(`${STATE_PREFIX}${group}`);
      if (!raw) return;
      const wanted = raw.split('||');

      details.querySelectorAll('input[data-mac-filter-checkbox]').forEach((input) => {
        const key = input.dataset.macFixedFinish ? `@${input.dataset.macFixedFinish}` : labelFor(input);
        input.checked = wanted.includes(key);
      });
    });
  };

  const setVisualState = (sidebar) => {
    sidebar.querySelectorAll('li[data-filter-item]').forEach((li) => {
      li.classList.toggle('is-active', Boolean(li.querySelector('input[data-mac-filter-checkbox]:checked')));
    });
  };

  const fetchUrl = (groups) => {
    const url = new URL('/search', window.location.origin);
    url.searchParams.set('view', 'mac-filter');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', buildQuery(groups));

    const stateUrl = new URL(window.location.href);
    const sort = stateUrl.searchParams.get('sort_by');
    if (sort) url.searchParams.set('sort_by', sort);
    PREVIEW_PARAMS.forEach((param) => {
      if (stateUrl.searchParams.has(param)) url.searchParams.set(param, stateUrl.searchParams.get(param));
    });
    return url;
  };

  const replaceResults = (doc, originalGridClass) => {
    const current = document.getElementById('ResultsList');
    const incoming = doc.getElementById('ResultsList');
    if (!current || !incoming) throw new Error('Product results container not found.');

    const currentInner = current.querySelector(':scope > div');
    const incomingInner = incoming.querySelector(':scope > div');
    if (!currentInner || !incomingInner) throw new Error('Product grid not found.');

    const incomingGrid = incomingInner.querySelector('.product-grid');
    if (incomingGrid && originalGridClass) incomingGrid.className = originalGridClass;
    currentInner.innerHTML = incomingInner.innerHTML;
  };

  const load = async (sidebar, groups, originalGridClass) => {
    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();

    const results = document.getElementById('ResultsList');
    sidebar.classList.add('mac-filters-loading');
    results?.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(fetchUrl(groups).toString(), {
        signal: activeRequest.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`Filter request failed (${response.status}).`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      replaceResults(doc, originalGridClass);
    } catch (error) {
      if (error.name !== 'AbortError') console.error('[MAC Pokémon filters]', error);
    } finally {
      sidebar.classList.remove('mac-filters-loading');
      document.getElementById('ResultsList')?.removeAttribute('aria-busy');
    }
  };

  const init = () => {
    const sidebar = document.querySelector('.mac-tcg-sidebar[data-mac-filter-panel], .mac-tcg-sidebar');
    const results = document.getElementById('ResultsList');
    if (!sidebar || !results) return;

    ensureFixedFinishOptions(sidebar);
    restoreState(sidebar);
    setVisualState(sidebar);

    const originalGridClass = document.querySelector('#ResultsList .product-grid')?.className || '';

    document.addEventListener('change', (event) => {
      const input = event.target.closest?.('.mac-tcg-sidebar input[data-mac-filter-checkbox]');
      if (!input) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();

      const groups = collect(sidebar);
      saveState(groups);
      setVisualState(sidebar);
      load(sidebar, groups, originalGridClass);
    }, true);

    document.addEventListener('click', (event) => {
      const clear = event.target.closest?.('.mac-tcg-sidebar [data-mac-clear-all]');
      if (!clear) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();

      sidebar.querySelectorAll('input[data-mac-filter-checkbox]').forEach((input) => { input.checked = false; });
      const url = new URL(window.location.href);
      [...url.searchParams.keys()].forEach((key) => {
        if (key.startsWith(STATE_PREFIX)) url.searchParams.delete(key);
      });
      window.history.replaceState({ macPokemonFilters: true }, '', url.toString());
      setVisualState(sidebar);
      load(sidebar, {}, originalGridClass);
    }, true);

    window.addEventListener('popstate', () => {
      restoreState(sidebar);
      setVisualState(sidebar);
      load(sidebar, collect(sidebar), originalGridClass);
    });

    if (Object.keys(collect(sidebar)).length) {
      load(sidebar, collect(sidebar), originalGridClass);
    }
  };

  ready(init);
})();
